import { apiRequest } from "../apiService/allapi";
import { successAlert } from "../apiService/sweetAlert";

const GUEST_CART_KEY = 'guestCart';

export const isLoggedIn = () => {
  return !!localStorage.getItem("token");
};

export const getGuestCart = () => {
  try {
    const cart = localStorage.getItem(GUEST_CART_KEY);
    return cart ? JSON.parse(cart) : [];
  } catch (error) {
    console.error("Error reading guest cart:", error);
    return [];
  }
};

export const setGuestCart = (cart) => {
  try {
    localStorage.setItem(GUEST_CART_KEY, JSON.stringify(cart));
  } catch (error) {
    console.error("Error saving guest cart:", error);
  }
};

export const addToGuestCart = (product) => {
  // Stock validation for guest
  if (product.stock !== undefined && product.qty > product.stock) {
    throw new Error(`Only ${product.stock} items available`);
  }

  const cart = getGuestCart();
  const existingIndex = cart.findIndex(item => item.pid === product.pid);
  
  if (existingIndex > -1) {
    const newQty = cart[existingIndex].qty + (product.qty || 1);
    if (product.stock !== undefined && newQty > product.stock) {
      throw new Error(`Cannot exceed stock limit of ${product.stock}`);
    }
    cart[existingIndex].qty = newQty;
  } else {
    cart.push({ ...product, qty: product.qty || 1 });
  }
  
  setGuestCart(cart);
  console.log('Guest cart after add:', cart);
  successAlert("Added to cart!");
  return cart;
};

export const removeFromGuestCart = (pid) => {
  const cart = getGuestCart().filter(item => item.pid !== pid);
  setGuestCart(cart);
  return cart;
};

export const updateGuestCartQty = (pid, qty) => {
  const cart = getGuestCart();
  const index = cart.findIndex(item => item.pid === pid);
  if (index > -1) {
    if (qty === 0) {
      return removeFromGuestCart(pid);
    }
    // Check stock if available
    if (cart[index].stock !== undefined && qty > cart[index].stock) {
      throw new Error(`Cannot exceed stock limit of ${cart[index].stock}`);
    }
    cart[index].qty = qty;
    setGuestCart(cart);
    return cart;
  }
  return cart;
};

export const clearGuestCart = () => {
  localStorage.removeItem(GUEST_CART_KEY);
};

export const computeGuestCartTotal = (cart) => {
  return cart.reduce((total, item) => total + (item.sellingPrice * item.qty), 0);
};

// 🔥 NEW: Get total cart count (qty sum) for Header badge
export const getTotalCartCount = async () => {
  if (isLoggedIn()) {
    // Server cart total qty
    try {
      const token = localStorage.getItem("token");
      const res = await apiRequest("/Cart/list", "GET", null, {
        Authorization: `Bearer ${token}`,
      });
      if (res?.data?.status === true) {
        const items = res?.data?.data?.data || [];
        return items.reduce((total, item) => total + Number(item.qty || 0), 0);
      }
    } catch (error) {
      console.log("Server cart count error:", error);
    }
    return 0;
  } else {
    // Guest cart total qty
    const cart = getGuestCart();
    return cart.reduce((total, item) => total + Number(item.qty || 0), 0);
  }
};

// 🔥 NEW: Dispatch cart update event
export const dispatchCartUpdate = () => {
  window.dispatchEvent(new CustomEvent('cartCountUpdated'));
};

// 🔥 NEW: Check if product is already in cart (guest or server)
export const isProductInCart = async (pid) => {
  if (isLoggedIn()) {
    try {
      const token = localStorage.getItem("token");
      const res = await apiRequest("/Cart/list", "GET", null, {
        Authorization: `Bearer ${token}`,
      });
      if (res?.data?.status === true) {
        const items = res?.data?.data?.data || [];
        return items.some(item => item.pid === pid || item.productId === pid);
      }
    } catch (error) {
      console.error("Cart check error:", error);
    }
    return false;
  } else {
    const cart = getGuestCart();
    return cart.some(item => item.pid === pid);
  }
};

// 🔥 NEW: Get current cart quantity for product
export const getCartItemQty = async (pid) => {
  if (isLoggedIn()) {
    try {
      const token = localStorage.getItem("token");
      const res = await apiRequest("/Cart/list", "GET", null, {
        Authorization: `Bearer ${token}`,
      });
      if (res?.data?.status === true) {
        const items = res?.data?.data?.data || [];
        const item = items.find(item => item.pid === pid || item.productId === pid);
        return item ? Number(item.qty || 0) : 0;
      }
    } catch (error) {
      console.error("Cart qty check error:", error);
    }
    return 0;
  } else {
    const cart = getGuestCart();
    const item = cart.find(item => item.pid === pid);
    return item ? Number(item.qty || 0) : 0;
  }
};


export const syncGuestCartToServer = async () => {
  const guestCart = getGuestCart();
  console.log("Guest Cart:", guestCart);

  const token = localStorage.getItem("token");
  console.log("Token:", token);

  if (!guestCart.length || !token) return;

  try {
    const results = await Promise.allSettled(
      guestCart.map(async (item) => {
        console.log("Sending item:", item);

        const res = await apiRequest(
          "/Cart/add-to-cart",
          "POST",
          {
            pid: item.pid,
            qty: item.qty,
          },
          {
            Authorization: `Bearer ${token}`,
          }
        );

        console.log("API RESPONSE:", res);
        if (!res?.data?.status) {
          throw new Error(res?.data?.message || `Failed to sync item ${item.pid}`);
        }
        return res;
      })
    );

    // Log failures
    const failures = results.filter(r => r.status === 'rejected');
    if (failures.length > 0) {
      console.error("Some items failed to sync:", failures);
    }

    console.log("Guest cart sync completed");

    localStorage.removeItem(GUEST_CART_KEY);
    window.dispatchEvent(new Event("cartUpdated"));

  } catch (error) {
    console.log("Cart sync failed:", error);
  }
};
